import styled, { css } from 'styled-components';
import { baseSpacing } from '../../components/chat/Base';
import { SpaceProps } from 'styled-system';
import { StyledFormField } from '../../components/chat/FormField/Styled';

export const MainWrapper = styled.div<{
  hasSidePanel?: boolean;
  isLoggedIn?: boolean;
}>`
  padding: ${(props) =>
    `calc(${
      props.isLoggedIn
        ? 'var(--sp-login-header-height)'
        : 'var(--sp-header-height)'
    } + ${props.hasSidePanel ? '0rem' : '1.25rem'}) 0 2.5rem`};

  ${({ theme }) => theme.mediaQueries.min.md} {
    padding: ${(props) =>
      `calc(var(--pc-header-height) + ${
        props.hasSidePanel ? '0rem' : '2.5rem'
      }) 0 2.5rem`};
  }
`;

export const Container = styled.div<{
  maxWidth?: string;
  padding?: string;
  alignMiddle?: boolean;
}>`
  width: 100%;
  margin: 0 auto;
  padding: 0 1rem;
  max-width: ${(props) => props.maxWidth || '52.8125rem'};
  ${(props) =>
    props.alignMiddle &&
    css`
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      transform: translateY(-50%);
    `};

  ${({ theme }) => theme.mediaQueries.min.md} {
    padding: ${(props) => props.padding || '0 2.5rem'};
  }
`;

/**
 * ログイン、初期設定、エラーなどのボックス
 */
export const ContentBox = styled.div<SpaceProps>`
  position: relative;
  background-color: ${(props) => props.theme.colors.greys.white};
  border: 1px solid ${(props) => props.theme.colors.greys.grey20};
  border-radius: ${(props) => props.theme.radii.default};
  padding: 2.5rem 2.5rem 3.75rem;
  font-size: ${(props) => props.theme.fontSizes.small.fontSize};
  line-height: ${(props) => props.theme.fontSizes.text.lineHeight};

  ${({ theme }) => theme.mediaQueries.min.md} {
    font-size: ${(props) => props.theme.fontSizes.text.fontSize};
  }

  ${baseSpacing}

  ${StyledFormField} {
    margin-left: auto;
    margin-right: auto;
    width: 26.25rem;
    max-width: 100%;
  }
`;

/**
 * ContentBoxみたいなボックスの中の中央ラッパー
 */
export const ContentInnerBox = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 26.25rem;
  max-width: 100%;
`;

/**
 * 文章の間に16pxの余白を空くボックス
 */
export const RowSpaceTextBox = styled.div`
  display: grid;
  row-gap: 0.75rem;

  ${({ theme }) => theme.mediaQueries.min.md} {
    row-gap: 1rem;
  }
`;

export const ErrorText = styled.p<SpaceProps>`
  font-size: ${(props) => props.theme.fontSizes.small.fontSize};
  line-height: ${(props) => props.theme.fontSizes.small.lineHeight};
  color: ${(props) => props.theme.colors.error.primary};
  word-break: break-word;

  ${baseSpacing}
`;

/**
 * テーブル表示
 */
export const StyledTable = styled.table`
  border: none;
  border-collapse: separate;
  border-spacing: 0px;
  background-color: ${(props) => props.theme.colors.greys.white};
  word-break: break-word;

  td,
  th {
    padding: 0.5rem 0.75rem;
    vertical-align: middle;
  }

  td {
    border-bottom: 1px solid ${(props) => props.theme.colors.greys.grey10};
  }
`;
